import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

type LabelDiscriminatedTypes =
  | {
      Component: React.ElementType;
    }
  | {
      htmlFor: string;
    };

type LabelProps = LabelDiscriminatedTypes & { className?: string };

export const Label: React.FC<LabelProps> = (props) => {
  const { className, children } = props;
  const classes = createLabelStyles(useTheme());

  if ("htmlFor" in props) {
    return (
      <label htmlFor={props.htmlFor} className={cx(classes.label, className)}>
        {children}
      </label>
    );
  }
  return (
    <props.Component className={cx(classes.label, className)}>
      {children}
    </props.Component>
  );
};

const createLabelStyles = ({ typography, palette, spacing }: Theme) => {
  return {
    label: css({
      display: "inline-block",
      fontSize: typography.pxToRem(13),
      color: palette.secondary.text,
      padding: spacing([0, 2, 1, 2]),
    }),
  };
};
